import React, { useMemo } from 'react';
import { AppButton, Box, RenewalCanceledBannerIcon } from '@common-fe/common-fe';

import { OrganizationTypes } from '@/common/constants';
import Permissions from '@/common/permissions';
import { BannerBase } from '@/modules/core/components/Banners';
import { useCurrentOrganization, useHasAccess } from '@/modules/core/hooks';

interface RenewalCanceledBannerProps {
  onSetConfirmRenewModalVisible: () => void;
  onSetRenewDetailModalVisible: () => void;
}

const RenewalCanceledBanner: React.FC<RenewalCanceledBannerProps> = ({
  onSetConfirmRenewModalVisible,
  onSetRenewDetailModalVisible,
}) => {
  const hasAccess = useHasAccess([{ permission: Permissions.PLAN_SETUP }]);
  const { defaultOrganizationData } = useCurrentOrganization();

  const isConfirmButtonVisible = useMemo(
    () => hasAccess && (defaultOrganizationData?.type === OrganizationTypes.system
    || defaultOrganizationData?.type === OrganizationTypes.partner
    || defaultOrganizationData?.type === OrganizationTypes.distributor), [defaultOrganizationData?.type, hasAccess]);

  return (
    <Box>
      <BannerBase
        title="Your Non-renewal Request Has Been Sent"
        description="You've chosen not to renew your plans. Your reasoning is listed in details to this banner. An account manager will reach out to gather additional details."
        icon={<RenewalCanceledBannerIcon />}
        testId="renewal-canceled-report"
      >
        <Box  direction="row" margin={{top: 'l'}} gap="s">
          <AppButton width="160px" onClick={onSetRenewDetailModalVisible}>
            View Details
          </AppButton>
          {isConfirmButtonVisible && (
            <AppButton width="160px" onClick={onSetConfirmRenewModalVisible} buttonType="secondary">
              Mark as Complete
            </AppButton>
          )}
        </Box>
      </BannerBase>
    </Box>
  );
};

export default RenewalCanceledBanner;
